import Vue from 'vue'
import { RepositoryFactory } from '../repositories/RepositoryFactory'
// console.log(RepositoryFactory);
const ContactUsRepository = RepositoryFactory.get('contactus')

const state = {
  status: '',
  isLoggedIn: false,
  loggedInUser: {}
}

const mutations = {
  'SUBMIT_FORM': (state, { token, loginModalRef, user }) => {
    localStorage.setItem('token', token)
    // state.isLoggedIn = true
    if (loginModalRef) {
      loginModalRef.click()
    }
    state.loggedInUser = user
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.removeItem('financialObjTemp')
    localStorage.removeItem('codesObject')
    localStorage.removeItem('inputOneSelectedData')
    Vue.routerInstance.push('/transformation-input')
  }
}

const actions = {
  /**
   * User Login
   */
  'SUBMIT_FORM': async ({ commit }, formData) => {
    try {
      // commit('ISLOADING', true)
      let response = await ContactUsRepository.save(formData)
      console.log('Response')
      commit('RESET_SUBMIT')
      // commit('ISLOADING', false)
      // commit('NOTIFICATION', { message: 'Thank you' })
      return response
    } catch (e) {
      console.log('Error')
      commit('RESET_SUBMIT')
      commit('NOTIFICATION', e.response.data)
      // commit('ISLOADING', false)
      return e.response
    }
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/modules/contact_us.js